import { Component, Input } from '@angular/core';
import { Brand } from '../../core/brand';
import { CONSTANTS } from '../constants/constants';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss']
})
export class SocialMediaComponent {
  @Input() brand: Brand;
  public readonly constants = CONSTANTS;
}
